<template>
  <div class="krs019">
    <ul>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.001","권한아이디")}}</dt>
          <dd>
            <div class="txt">
              <input type="text" v-model="roleId" 
                    @input="displayBytes('roleId', roleId, $event)" 
                    :placeholder="$i18nUtil.trans('message.RoleRegist.001','권한아이디를 입력해 주세요.')"/>
              <div class="error" v-if="roleIdError">{{$i18nUtil.trans("message.RoleRegist.001","권한아이디를 입력해 주세요.")}}</div>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.002","권한명")}}</dt>
          <dd>
            <div class="txt">
              <input type="text" v-model="roleName" 
                    @input="displayBytes('roleName', roleName, $event)" 
                    :placeholder="$i18nUtil.trans('message.RoleRegist.002','권한명을 입력해 주세요.')"/>
              <div class="error" v-if="roleNameError">{{$i18nUtil.trans("message.RoleRegist.002","권한명을 입력해 주세요.")}}</div>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.003","권한설명")}}</dt>
          <dd>
            <div class="txt">
              <input type="text" v-model="description" 
                    @input="displayBytes('description', description, $event)" 
                    :placeholder="$i18nUtil.trans('message.RoleRegist.003','권한설명을 입력해 주세요.')"/>
              <div class="error" v-if="descriptionError">{{$i18nUtil.trans("message.RoleRegist.003","권한설명을 입력해 주세요.")}}</div>
            </div>
          </dd>
        </dl>
      </li>      
      <button
              type="button"
              class="btn-primary-small black"
              @click="checkInputData"
              style="float: right; margin-top: 10px;"
      >{{$i18nUtil.trans("button.save","저장")}}
      </button>
    </ul>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  components: {
    Dialog,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      checkError: 0,
      roleIdError: false,
      roleNameError: false,
      descriptionError: false,
      roleId: null,
      roleName: null,
      description: null,      
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },  
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    displayBytes(roleData, text, _event) {
      if(this.checkError == 1){
        let obj = this;
        text = _event.target.value;
        let checkBytes = obj.getByteLength(text);
        if(checkBytes > 0) {
          if(roleData == 'roleId'){
            obj.roleIdError = false;
          }else if(roleData == 'roleName'){
            obj.roleNameError = false;
          }else if(roleData == 'description'){
            obj.descriptionError = false;
          }
        }else{
          if(roleData == 'roleId'){
            obj.roleIdError = true;
          }else if(roleData == 'roleName'){
            obj.roleNameError = true;
          }else if(roleData == 'description'){
            obj.descriptionError = true;
          }
        }
      }
    },
    getByteLength(str) {
      if (str == null || str.length == 0) {
          return 0;
      }
      var size = 0;
      for ( var i = 0; i < str.length; i++) {
          size += this.charByteSize(str.charAt(i));
      }
      return size;
    },
    charByteSize(ch) {
      if (ch == null || ch.length == 0) {
          return 0;
      }
      var charCode = ch.charCodeAt(0);

      if (charCode <= 0x00007F) {
          return 1;
      } else if (charCode <= 0x0007FF) {
          return 2;
      } else if (charCode <= 0x00FFFF) {
          return 2;
      } else {
          return 2;
      }
    },
    checkInputData(){
      this.checkError = 1;
      if(this.roleId == null || this.roleId == undefined || this.roleId.length == 0){
        this.roleIdError = true;
        return;
      }else{
        this.roleIdError = false;
      }
      if(this.roleName == null || this.roleName == undefined || this.roleName.length == 0) {
        this.roleNameError = true;
        return;
      }else{
        this.roleNameError = false;
      }
      if(this.description == null || this.description == undefined || this.description.length == 0) {
        this.descriptionError = true;
        return;
      }else{
        this.descriptionError = false;
      }
      this.registRole();
      this.checkError = 0;
    },
    registRole() {
      let obj = this;
      
      let reqData = {};
      reqData.params = {
        roleId: this.roleId,
        roleName: this.roleName,
        description: this.description,        
      };
      reqData.url = "/api/org/role/registRole";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleRegist.004","권한이 등록되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.$emit("registRole");
            this.roleId = null;
            this.roleName = null;
            this.description = null;            
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
  },
};
</script>

<style scoped>
.krs019 > ul > li > dl > dt {
  width: 150px;
  padding-top: 5px;
}
.krs019 > ul > li > dl > dd {
  width: 900px;
}
.krs019 > ul > li > dl > dd > div > input {
  width: 85%;
  border: 1px solid #E6E6E8;
}
.krs019 > ul > li > dl > dd > div > div {
  width: 15%;
  float: right;
  padding-top: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/RoleRegist.vue